export default __webpack_public_path__ + "static/ism-home-desktop2-e07542df52a88209a14df20284721743.png";